module.exports = __webpack_public_path__ + "img/schnittkante_karminrot_ral3002.be0d4d7e.jpg";